<template>
  <div class="Container">

    <slot></slot>

  </div>
</template>

<script>
export default {}
</script>

<style>
@import 'properties';

.Container {
  margin: 0 auto;
  padding: 0 var(--unit);
  max-width: 1008px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Container.vue?2e42c443